import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BaseApiTemplateService, Core2Config } from "../../shared";

//https://api.akaun.cloud/core2/tnt/dm/erp/gen-doc/login-entity-ep/xtn-process/

@Injectable({ providedIn: "root" })
export class GenericDocXtnProcessService extends BaseApiTemplateService<any> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX +  Core2Config.ERP_PREFIX + "gen-doc/login-entity-ep/xtn-process";
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX +  Core2Config.ERP_PREFIX + "gen-doc/login-entity-ep/xtn-process";
    this.httpClient = http;
  }
}
